import React from "react"
import { Container } from "./Container"
import { Card } from "./Card"
import { Pill } from "./Pill"
type Props = {
  children?: React.ReactNode
  label?: string | JSX.Element
  className?: string
  title: string
  date?: string
  smallTitle?: boolean
}

export const Hero = ({
  children,
  label,
  className,
  title,
  date,
  smallTitle,
}: Props) => {
  return (
    <div className={"sm:half-blue " + className}>
      <Container className=" relative pt-12 lg:pt-20">
        <Card shadow="m">
          {label && (
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 grow align-items-center flex flex-row">
              <Pill text={label} />
            </div>
          )}
          <div className="max-w-screen-lg	 mx-auto text-center my-4">
            <div className="uppercase font-medium text-sm text-gray-700 my-12">
              {date}
            </div>
            <h1
              className={`break-words hyphens-auto sm:hyphens-manual ${
                smallTitle ? "text-2xl sm:text-5xl" : "text-4xl sm:text-6xl"
              }`}
            >
              {title}
            </h1>
            <div className="text-lg text-gray-800">{children}</div>
          </div>
        </Card>
      </Container>
    </div>
  )
}
